module.exports = __webpack_public_path__ + "img/pen-slash.77ced614.svg";